import { render, staticRenderFns } from "./ReservationMemberCard.vue?vue&type=template&id=c1761454&scoped=true"
import script from "./ReservationMemberCard.vue?vue&type=script&lang=js"
export * from "./ReservationMemberCard.vue?vue&type=script&lang=js"
import style0 from "./ReservationMemberCard.vue?vue&type=style&index=0&id=c1761454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1761454",
  null
  
)

export default component.exports